import { GET_ALL_ORDER_NUMBER, UPDATE_STATUS_FOR_DISPATCH, UPDATE_DISPATCH_STATUS, } from '../type'


const initialState = {
    allOrderNumber: [],
    updateStatus: [],
    updateDispatchStatus: [],
}

export default function orderNoReducer(state = initialState, action) {
    switch (action.type) {

        case GET_ALL_ORDER_NUMBER:
            return {
                ...state,
                loading: false,
                allOrderNumber: action.payload
            }
        case UPDATE_STATUS_FOR_DISPATCH:
            return {
                ...state,
                loading: false,
                updateStatus: action.payload
            }
        case UPDATE_DISPATCH_STATUS:
            return {
                ...state,
                loading: false,
                updateDispatchStatus: action.payload
            }


        default: return state
    }



}